module.exports = __webpack_public_path__ + "img/Logo Blue.4cbbceab.svg";